<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ep2"> </p>
<p class="EP">Victoria, mysterious child,</p>
<p class="EP">Mix of my blood</p>
<p class="EP">Will you turn out as wild?</p>
<p class="EPC"><span class="ePub-SC">—LOUIS LOUSTALOT, </span><span class="R">winter 1996,</span></p>
<p class="EPC"><span class="ePub-I">as scrawled on a piece of scrap paper</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph2.vue?ebc7c9dc